import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaBars, FaXmark } from "react-icons/fa6";
import "./CSS/public-navigation.css";

export default function HomePage() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="public-nav-shell">
      <nav className="public-nav" aria-label="Main navigation">
        <Link className="public-brand" to="/" onClick={closeMenu} aria-label="CircleGrid home">
          <span className="public-brand-mark"><i /></span>
          CircleGrid
        </Link>

        <div className={`public-nav-menu ${menuOpen ? "open" : ""}`}>
          <Link to="/" onClick={closeMenu}>Website Builder</Link>
          <Link to="/Directory" onClick={closeMenu}>Directory</Link>
          <Link to="/buyers-portal" onClick={closeMenu}>Find Services</Link>
          <Link to="/Pricing" onClick={closeMenu}>Pricing</Link>
          <Link to="/guides" onClick={closeMenu}>Guides</Link>
          <Link to="/About" onClick={closeMenu}>About</Link>
          <div className="public-mobile-actions">
            <Link to="/Login" onClick={closeMenu}>Log in</Link>
            <Link className="public-nav-cta" to="/Signup" onClick={closeMenu}>Start building <FaArrowRight /></Link>
          </div>
        </div>

        <div className="public-nav-actions">
          <Link className="public-login" to="/Login">Log in</Link>
          <Link className="public-nav-cta" to="/Signup">Start building <FaArrowRight /></Link>
        </div>

        <button
          className="public-menu-toggle"
          type="button"
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <FaXmark /> : <FaBars />}
        </button>
      </nav>
    </header>
  );
}
